import { memo } from 'react';
import { SecretType } from 'api/model';
import { FaGitAlt, FaKey } from 'react-icons/fa6';
import { Typography } from '@mui/material';
import { IconType } from 'react-icons';
import { RiRobot2Fill } from 'react-icons/ri';

type IconOption = {
  Icon: IconType;
  size: number;
  text: string;
};

const ICON_OPTIONS: Record<SecretType, IconOption> = {
  api_key: {
    Icon: FaKey,
    size: 30,
    text: 'API Key',
  },
  git_auth: {
    Icon: FaGitAlt,
    size: 34,
    text: 'Git Auth',
  },
  coding_agent_credentials: {
    Icon: RiRobot2Fill,
    size: 34,
    text: 'Credentials',
  },
};

interface Props {
  type: SecretType;
  includeText?: boolean;
  scale?: number;
}

const SecretIcon = ({ type, includeText, scale = 1 }: Props) => {
  const { Icon, size, text } = ICON_OPTIONS[type];

  return includeText ? (
    <div className="flex items-center gap-2">
      <Icon size={size * scale} />
      <Typography variant="h6">{text}</Typography>
    </div>
  ) : (
    <Icon size={size * scale} />
  );
};

export default memo(SecretIcon) as React.FC<Props>;
